import { createFeatureSelector, createSelector } from "@ngrx/store";
import { selectPresentPolicies } from "../policy-store/policy.selectors";
import * as AppState from "../state";
import { featureKey, State } from "./state";

export const selectFeatureState = createFeatureSelector<AppState.State, State>(
  featureKey
);

export const selectAgencies = createSelector(
  selectFeatureState,
  (state) => state.policyAgencies
);

export const selectAgenciesPolicies = createSelector(
  selectAgencies,
  selectPresentPolicies,
  (agencies, policies) =>
    agencies.map((agency) => {
      return {
        agency,
        policies: policies.filter((policy) => policy.agencyId === agency.id),
      };
    })
);
